import { AgentUtility } from './agent.utility';
import type { RenderedItem } from './agent.types';

// [label](entity://Type/id) links only resolve inside the agent chat; pasted anywhere else they are dead
// links that carry internal ids, so the copy keeps just the label. A label may hold one level of brackets,
// as a record name like "Acme [Warehouse]" does.
const ENTITY_LINK = /\[((?:[^[\]]|\[[^[\]]*\])*)\]\(entity:\/\/[^)]*\)/g;

/**
 * The markdown a reader means by "copy this reply": the visible text after the message's last activity block
 * or card, or all of its visible text when nothing follows one. Reasoning, tool steps and the short connector
 * lines grouped into activity blocks are never part of it. Takes the items the message list already grouped
 * for rendering, so the copy always matches what is on screen and a reply is never grouped twice.
 */
export function agentMessageCopyText(items: RenderedItem[]): string {

  const texts = items.map(item => item.kind === 'text' ? AgentUtility.partField<string>(item.part, 'text', '').trim() : null);

  let lastWorkIndex = -1;
  items.forEach((item, index) => {
    if (item.kind === 'activity-block' || item.kind === 'special-tool') lastWorkIndex = index;
  });

  const finalTexts = texts.slice(lastWorkIndex + 1).filter(text => !!text);
  const copied = finalTexts.length
    ? finalTexts
    : texts.filter(text => !!text);

  return copied
    .join('\n\n')
    .replace(ENTITY_LINK, '$1');
}
